import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TicketState {
  type: string | null;
  status: string;
  category: string;
  subcategory: string;
  search: string;
  priority: string;
  refresh: boolean;
}

const initialState: TicketState = {
  type: 'my_tickets',
  status: "",
  category: "",
  subcategory: "",
  search: "",
  priority: "",
  refresh: false,
};

const ticketSlice = createSlice({
  name: "ticket",
  initialState,
  reducers: {
    updateType: (state, action: PayloadAction<string | null>) => {
      state.type = action.payload;
    },
    updateStatus: (state, action: PayloadAction<string>) => {
      state.status = action.payload;
    },
    updateCategoryId: (state, action: PayloadAction<string>) => {
      state.category = action.payload;
    },
    updateSubCategoryId: (state, action: PayloadAction<string>) => {
      state.subcategory = action.payload;
    },
    updateSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    updatePriority: (state, action: PayloadAction<string>) => {
      state.priority = action.payload;
    },
    resetFilters: (state) => {
      state.status = "";
      state.category = "";
      state.subcategory = "";
      state.search = "";
      state.priority = "";
    },
    setRefresh: (state, action: PayloadAction<{ refresh: boolean }>) => {
      state.refresh = action.payload.refresh;
    },
  },
});

export const {
  updateType,
  updateStatus,
  updateCategoryId,
  updateSubCategoryId,
  updateSearch,
  updatePriority,
  resetFilters,
  setRefresh,
} = ticketSlice.actions;

export default ticketSlice.reducer;
